/**
 * CargaCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {Carga} from '@/model/resource/Carga'

/* TODO: review generated class */
@HttpExclude()
export class CargaCollection extends PageCollection<Carga> {
  constructor() {
    super(Carga)
  }

  queryAsPage() {
    return this.listCarga()
  }

  async listCarga() {
    return await Request.get(`/admin/carga`, {params: this.params})
      .name('listCarga')
      .as(this)
      .getResponse()
  }

  async listCsvCarga() {
    return await Request.get(`/admin/carga/csv`, {params: this.params})
      .name('listCsvCarga')
      .as(this)
      .getResponse()
  }
}
